var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",attrs:{"id":"app"}},[_c('headertitle'),_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Footw')],1)}
var staticRenderFns = []

export { render, staticRenderFns }